import type { Partner } from "../types";
import { PartnerCreate, PartnerEdit } from "./PartnerForms";
import { PartnerList } from "./PartnerList";
import { PartnerShow } from "./PartnerShow";

export default {
  list: PartnerList,
  create: PartnerCreate,
  edit: PartnerEdit,
  show: PartnerShow,
  recordRepresentation: (record: Partner) => record.name,
};
